import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/_services/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class WelcomeGuard implements CanActivate {

  constructor(private sessionService: SessionService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isLocationAvailable = this.sessionService.isLocationAvailable(route.queryParamMap);
    if (isLocationAvailable && (this.sessionService.isGenRoute() || this.sessionService.isDocCheck())) {
      return true;
    }

    this.sessionService.isLocationAvailableInParams = false;
    return true;
  }

}
